import { render } from "./ModalPeople.vue?vue&type=template&id=69f40268&scoped=true"
import script from "./ModalPeople.vue?vue&type=script&lang=js"
export * from "./ModalPeople.vue?vue&type=script&lang=js"

import "./ModalPeople.vue?vue&type=style&index=0&id=69f40268&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69f40268"]])

export default __exports__